import { render, staticRenderFns } from "./HtCardFooter.vue?vue&type=template&id=1f84cc18&"
import script from "./HtCardFooter.vue?vue&type=script&lang=js&"
export * from "./HtCardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports